export const COMP_GRAPH_TYPES = {
  YEAR: 'Year',
  BUYER_NAME: 'Buyer Name',
  SELLER_NAME: 'Seller Name',
};

export const compGraphTypes = Object.values(COMP_GRAPH_TYPES).map((name) => ({
  label: name,
  value: name,
}));
export const compOptions = Object.values(COMP_GRAPH_TYPES).map((name) => name);

export const COMP_Y_GRAPH_TYPES = {
  VALUATION: 'Valuation',
  RESERVE: 'Reserve',
  PRODUCTION: 'Production',
};

export const compYOptions = Object.values(COMP_Y_GRAPH_TYPES).map((name) => name);
